import { Component } from "@mna/react";
import AnimationThankYou2 from "features/Animation/ThankYou2";
import { Trans } from "react-i18next";
import {enCounterToken} from "../../../state/triage/actions/utils"
import {checkAndGetLocalStorageValue} from "../../../features/utils";
let isComingFromDeclineCare = false;

export default class ThankYouSection extends Component {
  state = {
    isLoading: true,
    services: [],
  };

  componentDidMount() {
    const { state, setState } = this.props;
    var currentQueryString = window.location.search;
    if(state.isMenuClick){
      setState({isMenuClick:false})
    }

    if (currentQueryString) {
      isComingFromDeclineCare = true;
    } else {
      isComingFromDeclineCare = false;
    }

    if (!state.IsValidUser && !state.isFacility && !state.isTravelAid2) {
      setState({
        isTriageGoingForRegularUser: false,
      });
    }
  }

  render() {
    const { state, history, setState } = this.props;
    if(state.triageRequest.emergency || state.isFacility || state.triageRequest.isFacilitySearch){
      state.triageRequest.activeMenu = "emergency"
    }else{
    state.triageRequest.activeMenu = "care-options";
    }
    return (
      <div className="article-width px-2" style={{ maxWidth: "620px" }}>
        <div>
          <h1 className="text-center standby-page-header-title marginTop">
            <Trans i18nKey="findcareoption.Careoptions.Done.DoneScreenDeclineCareTitle"></Trans>
          </h1>

          <div className="screen-main-image" style={{ maxWidth: "520px" }}>
            <AnimationThankYou2 />
          </div>

          <div style={{ textAlign: "initial"}} >
            <Trans i18nKey="findcareoption.Careoptions.Done.ThankYouTitle">
            Should you require additional assistance, please do not hesitate to
            contact us by using one of the emergency phone numbers as found on
            your insurance documentation. Our assistance department is available
            24/7
            </Trans>
          </div>

          <div className="done-space">
            <button
              type="button"
              className=" button standby-button  standby-button-square-green btn-color-contrast"
              onClick={() => {
                enCounterToken();
                setState({
                  item: false,
                  phone:""
                })
                if(state.isTravelAid2 || state.triageRequest.isFacilitySearch){
                  gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
                  history.push({
                    pathname: "/triageNew",
                    search: "?organizationId=" + localStorage.getItem("orgid"),
                  });
                }
                else if (state.IsValidUser) {
                  gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
                  history.push({
                    pathname: "/terms",
                    search: "?organizationId=" + localStorage.getItem("orgid"),
                  });
                }
                else if(state.isFacility) {
                  gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
                  history.push({
                    pathname: "/find-facility",
                    search: "?organizationId=" + localStorage.getItem("orgid"),
                  });
                  sessionStorage.setItem("phoneField", false);
                  sessionStorage.setItem("EmailField", false);
                  window.location.reload();
                }
                else{
                  gtag('set', 'content_group', checkAndGetLocalStorageValue("orgid"));
                history.push("/terms");
              }}}
            >
              {isComingFromDeclineCare && state.declineCare ? (
                <Trans i18nKey="findcareoption.Careoptions.Done.startTriage">
                  Start Triage
                </Trans>
              ) : (
                <Trans i18nKey="findcareoption.Careoptions.Done.StartAnotherTriage">
                  Start another triage
                </Trans>
              )}
            </button>
          </div>
        </div>
      </div>
    );
  }
}
